import { createFileRoute, redirect } from '@tanstack/react-router'

import { loginWorker } from '@/api/auth'
import { cleanUpCookieandStorage } from '@/lib/token'
import { userQueryOptions, workerInfoQueryOptions } from '@/queries/auth'
import {
  orgFeesQueryOptions,
  orgInfoQueryOptions,
} from '@/queries/organization'
import { paymentProfileQueryOptions } from '@/queries/profile'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async ({ context: { queryClient, orgStore } }) => {
    const orgState = orgStore.getState()
    let orgId = orgState.orgId
    if (!orgId) {
      const workerInfo = await queryClient.ensureQueryData(
        workerInfoQueryOptions
      )
      orgId = workerInfo[0].org_uuid as string
      await loginWorker(workerInfo[0])
      if (orgId) orgState.setOrgId(orgId)
    }
    queryClient.prefetchQuery(userQueryOptions)
    queryClient.prefetchQuery(paymentProfileQueryOptions)
    queryClient.prefetchQuery(orgFeesQueryOptions(orgStore.getState().orgId))
    const promises: Promise<unknown>[] = [
      queryClient.ensureQueryData(userQueryOptions),
    ]

    if (orgId) {
      promises.push(queryClient.ensureQueryData(orgInfoQueryOptions(orgId)))
    }
    await Promise.all(promises)
  },
  onError: () => {
    cleanUpCookieandStorage()
    throw redirect({ to: '/login' })
  },
})
